import { APIClient } from '@/infrastructure/network/OpenAi/APIClient'

export class OpenAiGatewayBase {
  apiClient: APIClient

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
  }
}
